export class AssegnaTecnico {
    tecnicoId: string = "";
    assegnaPratichePrecedenti: boolean = false;
    societaId: number = 0;
}